module.exports = __webpack_public_path__ + "h5/img/company.bf5289df.png";